import { BEIGE_400, GRAY_700 } from 'constants/styling/upbrandingTheme'

import { BorderBoxWrapper } from 'components/common/BorderBoxWrapper'
import Box from '@mui/material/Box'
import { FC } from 'react'
import { MUIButton } from 'components/common/MUIButton'
import Stack from '@mui/material/Stack'
import { Trans } from 'react-i18next'
import Typography from '@mui/material/Typography'

/** @interface Props for the SignupCard component. */
interface Props {
  /** Sign up card title */
  title: string,
  /** Sign up card image */
  image: string,
  /** Sign up card description */
  description: string,
  /** Sign up card text */
  buttonText: string,
  /** Sign up card note under the card */
  note?: React.ReactNode,
  /** OnClick action leads to sign up flow */
  onClick: () => void,
}

/**
* @component 
 * SignupCard used in the SignUpPortal page (upbranding version)
 * 
 * @example
 * <SignupCard title="Client" image="card_img" description="tl;dr" button="Sign up" onClick={() => {}} /> 
 */
export const UpbrandingSignupCard: FC<Props> = ({
  title,
  image,
  description,
  buttonText,
  onClick,
  note
}) => {
  return (
    <Box width="36rem" height="100%">

      <BorderBoxWrapper
        borderRadius="0.6rem"
        backgroundColor={BEIGE_400}
        sx={{
          gap: '4rem',
          padding: '4rem',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          boxSizing: 'border-box',
          justifyContent: 'center',
        }}
      >

        <img
          src={image}
          alt={buttonText}
          style={{ width: '26rem', height: '22rem', borderRadius: '0.2rem', objectFit: 'cover' }}
        />

        <Stack gap="2rem" alignItems="center" justifyContent="center" width="100%">

          <Typography variant="display-sm">
            {title}
          </Typography>

          <Typography variant="text-sm" textAlign="center" color={GRAY_700}>
            <Trans>
              {description}
            </Trans>
          </Typography>

        </Stack>

        <MUIButton onClick={onClick} size="lg">
          <Typography variant="text-md" fontWeight={450}>
            {buttonText}
          </Typography>
        </MUIButton>

      </BorderBoxWrapper>

      <Stack marginTop="1.2rem" paddingX="2rem" textAlign="center">
        {note}
      </Stack>

    </Box>
  )
}
